<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding: 32px 0px;"' class="container-fluid background-gradiant" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding-top:64px;"' class="container-custom mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-center mx-auto align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 order-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="section-right-wrapper" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size: 3rem;\n"' class="title-h2-hero" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="text-tertiary" >
                <template #default>درباره   </template>
                </m-span><m-span v-bind='{...{},...{}}' :style='""' class="text-dark" >
                <template #default>خانه روان جیهان   </template>
                </m-span></template>
                </m-h1><m-h2 v-bind='{...{},...{}}' :style='"font-size: 1.2rem;"' class="my-5 " >
                <template #default>خانه روان جیهان با تمرکز بر سه محور اصلی «درمان، آموزش و پژوهش» فعالیت میکند. زمینه های کاری
مجموعه شامل ارائه خدمات روانشناختی آنالین، آموزش و توانمندسازی مراجعان و متخصصان، تولید محتوای
علمی و قابلفهم در حوزه سالمت روان، برگزاری کارگاههای تخصصی و توسعه فعالیتهای پژوهشی است.
   </template>
                </m-h2><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-start " >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='"font-size:13px;"' class=" mx-2 text-tertiary border-primary col-lg-4 col-md-5 mb-2" >
                <template #default>بازگشت به صفحه اصلی   <m-icon v-bind='{...{"icon":""},...{}}' :style='""' class="bi bi-arrow-left-circle-fill mx-1" ></m-icon></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6  order-1 order-lg-2 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.ravanjeyhan.ir\/storage\/icons\/ChatGPT_Image_Jul_26__2026__03_56_26_PM-removebg-preview.png","alt":"ravanjeyhan"},...{}}' :style='""' class="img-fluid " ></m-img></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"padding: 64px 0px;"' class="container-fluid background-gradiant" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-custom" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center mb-2 " >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.ravanjeyhan.ir\/storage\/icons\/ChatGPT_Image_Jul_26__2026__03_56_26_PM-removebg-preview.png","alt":"ravanjeyhan"},...{}}' :style='""' class="img-fluid" ></m-img></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center mb-2 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-right" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='""' class="mb-4 font-weight-bold text-dark" >
                <template #default>درباره خانه روان جیهان   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>خانه روان جیهان با تمرکز بر سه محور اصلی «درمان، آموزش و پژوهش» فعالیت میکند. زمینه های کاری
مجموعه شامل ارائه خدمات روانشناختی آنالین، آموزش و توانمندسازی مراجعان و متخصصان، تولید محتوای
علمی و قابلفهم در حوزه سالمت روان، برگزاری کارگاههای تخصصی و توسعه فعالیتهای پژوهشی است.
   </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-start " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mb-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding:16px;\nborder-radius: 8px;"' class="bg-white shadow-sm" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-success" >
                <template #default>10+   </template>
                </m-h3><m-h3 v-bind='{...{},...{}}' :style='"font-size: 20px;"' class="" >
                <template #default>سال سابقه فعالیت   </template>
                </m-h3></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mb-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding:16px;\nborder-radius: 8px;"' class="bg-white shadow-sm" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-warning " >
                <template #default>10000+   </template>
                </m-h3><m-h3 v-bind='{...{},...{}}' :style='"font-size: 20px;"' class="" >
                <template #default>مشتری راضی   </template>
                </m-h3></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mSpan,mH2,mA,mIcon,mImg,mP,mH3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
